import { Injectable } from '@angular/core';
import { FlamingoAuthService } from './flamingo-auth.service';

@Injectable({
  providedIn: 'root',
})
export class FlamingoAuthGuard {
  constructor(private authService: FlamingoAuthService) {}

  canLoad(): boolean {
    return this.authService.hasAuthorizationToken;
  }

  canActivate(): boolean {
    return this.authService.hasAuthorizationToken;
  }

  canActivateChild(): boolean {
    return this.authService.hasAuthorizationToken;
  }
}
